const STUDENT_CHAT = [
  {
    id: 1,
    name: "Justice Roy",
    text: "Good Morning",
    time: "10:30",
    messageCount: "3",
  },
  {
    id: 2,
    name: "Jasmine Cornoy",
    text: "Good Day",
    time: "1:30",
    messageCount: "2",
  },
  {
    id: 3,
    name: "Baby Ray",
    text: "Love u",
    time: "12:00",
    messageCount: "9",
  },
  {
    id: 4,
    name: "Lilian Betty",
    text: "See Ya!",
    time: "4:33",
    messageCount: "6",
  },
];

export default STUDENT_CHAT;
